// Big centered app title, shown at the top of the app. Words only: the app's mark is
// already in the sidebar's brand, and a second copy of it beside the name said nothing
// the name did not.
export function AppTitle({ title }: { title?: string }) {
  if (!title) return null;
  return (
    <div className="flex items-center justify-center">
      <h1 className="font-sora text-3xl font-bold tracking-wide text-slate-100">{title}</h1>
    </div>
  );
}
